import apiClient from "./apiClient";

export const sendContactMessage = async (data) => {
  try {
    const response = await apiClient.post("/contact", data);
    return { success: true, data: response.data };
  } catch (error) {
    console.error("Error sending contact message:", error);
    return { success: false, error: error.response?.data || "Something went wrong" };
  }
};
